import { normalize, schema } from 'normalizr';
import { LOGOUT_SUCCESS } from '../actions/logout';
import api from '../api';

const QUESTIONS_LIST_SUCCESS = api.events.questionsList.actionSuccess;
const QUESTIONS_CREATE_SUCCESS = api.events.questionsCreate.actionSuccess;
const QUESTIONS_PATCH_SUCCESS = api.events.questionsPatch.actionSuccess;
const QUESTIONS_RESET = api.events.questionsList.actionReset;

const questionSchema = new schema.Entity(
  'questions',
  {},
  {
    processStrategy: value => ({
      ...value,
      date: new Date(value.date)
    })
  }
);

const questionListSchema = new schema.Array(questionSchema);

const defaultState = {};

export default function(state = defaultState, action) {
  switch (action.type) {
    case QUESTIONS_CREATE_SUCCESS: {
      const normalizedData = normalize(action.data, questionSchema);
      return {
        ...state,
        ...normalizedData.entities.questions
      };
    }

    case QUESTIONS_RESET: {
      return {};
    }

    case QUESTIONS_PATCH_SUCCESS: {
      const normalizedData = normalize(action.data, questionSchema);
      return {
        ...state,
        ...normalizedData.entities.questions
      };
    }

    case QUESTIONS_LIST_SUCCESS: {
      const normalizedData = normalize(action.data, questionListSchema);
      return {
        ...normalizedData.entities.questions
      };
    }

    case LOGOUT_SUCCESS:
      return defaultState;

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/questions.js